import React from 'react'
import SarasDD from '../../input/dropdown/SarasDD'

const FormDropDown = (props) => {
    const { formObject, action, rowKey, headerKey, dataList, className, ...restProps } = props;
    
    const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");

    const onSelectChange = (e, value) => {

        if (formObject.onFormValueChange) formObject.onFormValueChange(action, rowKey, headerKey, value);

        //send the parameters reqired by the form
        if (action.actionId) formObject.onFormAction(action, rowKey, headerKey);
    }

    const createDataList = () => {
        
        let list = dataList;

        if(!list && Object.keys(viewData.dataList).length > 0)
        {
            list = [];
            let dataArray = Object.keys(viewData.dataList)

            for (var i = 0; i < dataArray.length; i++) {
                if(dataArray[i] !== 'isHid'){
                    list.push({key: dataArray[i], val: viewData.dataList[dataArray[i]]});
                }
            }
        }

        delete list['isHid'];
        return list;
    }

    if (viewData && hide === "0")
    {
        return (
            <SarasDD onChange={onSelectChange} currentValue={viewData.val} dataList={createDataList()} ctrlClass={className}  {...restProps} />
        )
    }

    return (null);
}

export default FormDropDown